import { createStorageValue } from '@interhyp/platform-storage';
import { createValue } from '@interhyp/platform-value';
import { z } from 'zod';
import { mortgageIntentNamespace } from '../namespaces';
/* current loans and leasing fees
 */
export const currentLoansMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('currentLoansMemory'),
    schema: z.number().nullable(),
});
export const currentLoansStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('currentLoans'),
    schema: z.number(),
    type: 'local',
});
